export default __webpack_public_path__ + "static/media/toycove.66736fe7.png";